/**
 * 契約カテゴリの定義
 */
export const ContractType = {
  EMPLOYMENT: 'EMPLOYMENT',
  // 雇用契約
  BOARD_MEMBER: 'BOARD_MEMBER',
  // 役員委任契約
  DELEGATION: 'DELEGATION',
  // 委任契約
  SERVICE: 'SERVICE',
  // 業務委託
  LEASE: 'LEASE',
  // リース
  SUBSCRIPTION: 'SUBSCRIPTION',
  // サブスクリプション契約
  PURCHASE: 'PURCHASE',
  // 購買契約
  SAAS_SOFTWARE: 'SAAS_SOFTWARE',
  // SaaS・ソフトウェア
  OFFICE_RENTAL: 'OFFICE_RENTAL',
  // オフィス賃貸
  OTHER: 'OTHER',
  // その他
  ALL: 'ALL'
} as const;
export type ContractType = (typeof ContractType)[keyof typeof ContractType];